module.exports = __webpack_public_path__ + "media/locationpin.88076ab1.svg";